export class ChatCopyGuest {
  public firstName: string;
  public lastName: string;
  public date: number;
  public isCustomer: boolean;
  public isFullCopy: boolean;
  public copyKey: string;

  constructor(
    firstName: string,
    lastName: string,
    date: number = 0,
    isCustomer: boolean = false,
    isFullCopy: boolean = false,
    copyKey: string = ''
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.date = date;
    this.isCustomer = isCustomer;
    this.isFullCopy = isFullCopy;
    this.copyKey = copyKey;
  }

  static isFromUnknownContact(copyGuest: ChatCopyGuest): boolean {
    return !(copyGuest.firstName && copyGuest.lastName);
  }
}
